import React from 'react';
import Header from './Header/Header';
import Sidebar from './Sidebar/Sidebar';

const Layout = (props) => {
  return (
    <React.Fragment>
      <Header />
      <Sidebar />
      {/* {props.children} */}
    </React.Fragment>
  );
};

export default Layout;
